/* eslint-disable no-unused-vars */
import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Selecter } from 'lego-dist';

import useCenters from 'hooks/centers/UseCenters';
import {
  Wrapper,
  InputGroup,
  Label,
  WrapperSelecter,
  MoveTeacherBtn,
  FootWrapper,
  InputGrid,
} from './styles';

export interface MoveTeacherProps {
  handleOnClickMoveTeacher?: (centers?: any, groups?: any) => any;
}

const MoveTeacher: React.FC<MoveTeacherProps> = ({
  handleOnClickMoveTeacher,
}) => {
  const { t: translate } = useTranslation();
  const [centersSelected, setCentersSelected] = useState<any[]>([]);
  const [groupsSelected, setGroupsSelected] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const { centerList } = useCenters();

  const buildCenterList = () =>
    centerList?.map((center: any) => ({
      ...center,
      label: center?.name,
      value: center?.id,
      name: center.name,
    }));

  useMemo(() => {
    if (centersSelected?.length) {
      const buildGroups: any = centersSelected.flatMap((center: any) =>
        center?.groups?.map((group: any) => ({
          ...group,
          label: group?.name,
          value: group?.id,
          parent_id: center.id,
          selected: false,
          parent: { ...center, ...{ selected: false } },
        })));
      setGroupList(buildGroups || []);
    } else {
      setGroupList([]);
    }
  }, [centersSelected]);

  return (
    <Wrapper>
      <span>
        {translate('settings:CENTER_SECTION.MOVE_TEACHER.DESCRIPTION')}
      </span>
      <InputGrid>
        <InputGroup>
          <Label>
            <span>
              {translate('settings:CENTER_SECTION.MOVE_TEACHER.LABEL')}
            </span>
          </Label>
          <WrapperSelecter>
            <Selecter
              autoOpen
              data={buildCenterList()}
              name="classrooms"
              value={centersSelected.map((c: any) => c?.id)}
              onChange={(values: any) => setCentersSelected(values)}
              multiple
              checkbox
              placeholder={translate(
                'settings:CENTER_SECTION.MOVE_TEACHER.PLACEHOLDER',
              )}
              search
            />
          </WrapperSelecter>
        </InputGroup>
        <InputGroup>
          <Label>
            <span>
              {translate('settings:CLASSROOMS')}
            </span>
          </Label>
          <WrapperSelecter>
            <Selecter
              autoOpen
              data={groupList}
              name="classrooms"
              value={groupsSelected}
              onChange={(values: any) => setGroupsSelected(values)}
              placeholder={translate(
                'settings:CENTER_SECTION.ASSIGNED_CLASSROOMS',
              )}
              multiple
              checkbox
              returnValue="list"
              groupBy="parent"
              search
            />
          </WrapperSelecter>
        </InputGroup>
      </InputGrid>
      <FootWrapper>
        <MoveTeacherBtn
          rounded
          disabled={!groupsSelected?.length}
          flat
          fill
          color="#75B753"
          onClick={() => {
            if (handleOnClickMoveTeacher) handleOnClickMoveTeacher(centersSelected, groupsSelected);
          }}
        >
          {translate('settings:CENTER_SECTION.MOVE_TEACHER.BTN')}
        </MoveTeacherBtn>
      </FootWrapper>
    </Wrapper>
  );
};

export default MoveTeacher;
